import { render, staticRenderFns } from "./APCodeUpload.vue?vue&type=template&id=ba180dac&"
import script from "./APCodeUpload.vue?vue&type=script&lang=js&"
export * from "./APCodeUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports